import { PlusIcon } from "@heroicons/react/20/solid"
import React, { useState, useEffect } from "react"

import { connect } from "react-redux"

import { Actions as LEAVEADJUSTMENTACTIONS } from "../../store/actions/leaveAdjustmentActions"

const AddLeaveAdjustment = ({ setOpenLeaveAdjustmentModal }) => {
   return (
      <div
        id="add-leave-adjustment-btn"
         className="btn btn-success pull-right"
         style={{ marginLeft: 10 }}
         onClick={setOpenLeaveAdjustmentModal}>
         <PlusIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
         <div style={{ float: "left" }}>Adjust Leave Balances</div>
      </div>
   )
}

const mapStateToProps = () => {
   return {}
}

const mapDispatchToProps = (dispatch) => ({
   setOpenLeaveAdjustmentModal: () =>
      dispatch(LEAVEADJUSTMENTACTIONS.setOpenLeaveAdjustmentModal(true)),
})

export default connect(mapStateToProps, mapDispatchToProps)(AddLeaveAdjustment)
